import { OpenSansText } from "@Components/CustomText/OpenSansText"
import { baseColors } from "@Constants/baseStyles"
import { Ionicons } from "@expo/vector-icons"
import React from "react"
import { StyleSheet, TouchableOpacity, View } from "react-native"

export const CustomTouchable = (props) => {
    return (
        <TouchableOpacity
            disabled={props.disabled}
            onPress={() => props.onPress && props.onPress()}
            activeOpacity={0.6}
        >
            <View style={styles.container}>
                <OpenSansText color={baseColors.green.primary} fontSize={16}>
                    {props.title}
                </OpenSansText>
                {!props.simple && <Ionicons color={baseColors.green.primary} size={20} name={"chevron-down"} />}
            </View>
        </TouchableOpacity>
    )
}

const styles = StyleSheet.create({
    container: {
        justifyContent: "space-between",
        height: 47,
        paddingHorizontal: 10,
        alignItems: "center",
        backgroundColor: baseColors.green.light,
        borderRadius: 10,
        flexDirection: "row"
    }
})
